import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Navbar,
  Button,
  Progress,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import ProcessingProgress from '../ProcessingProgress';

const UploadPageActionBar = ({
  submittedFiles,
  selectedFiles,
  saving,
  finishing,
  incompletedFiles,
  handleSelectAllFiles,
  handleUnselectAllFiles,
  handleRemoveSelectedFiles,
  handleDone,
  handleRetryAllFailed,
  overallProgress,
}) => {
  const intl = useIntl();

  const selectAllVisible = submittedFiles.length > 0 &&
    submittedFiles.length > selectedFiles.length;
  const unselectAllVisible = selectedFiles.length > 0;

  const anyFilesFailed = submittedFiles.find(f => f.uploadStatus === 'failed');

  return (
    <div className="actionbar active">
      <Container fluid>
        <Navbar className="navbar-expand">
          <div className="files-selected">
            {selectedFiles.length > 0 && (
              <span className="files-selected-num">
                {intl.formatMessage({
                  defaultMessage: '{selectedFilesCount} {selectedFilesCount, plural, one {selected file} other {selected files}}',
                }, {
                  selectedFilesCount: selectedFiles.length,
                })}
              </span>
            )}
            {(selectAllVisible && !saving) && (
              <span>
                <Button
                  color="link"
                  className="files-select-all"
                  onClick={handleSelectAllFiles}
                >
                  {intl.formatMessage({ defaultMessage: 'Select all' })}
                </Button>
              </span>
            )}
            {unselectAllVisible && (
              <span>
                <Button
                  color="link"
                  className="files-unselect-all"
                  onClick={handleUnselectAllFiles}
                >
                  {intl.formatMessage({ defaultMessage: 'Unselect all' })}
                </Button>
              </span>
            )}
          </div>
          <div className="files-actions">
            {saving && !finishing && (
              <Progress
                value={overallProgress}
              />
            )}
            {selectedFiles.length > 0 && (
              <Button
                color="secondary"
                onClick={handleRemoveSelectedFiles}
              >
                {intl.formatMessage({
                  defaultMessage: 'Remove {selectedFilesCount} {selectedFilesCount, plural, one {file} other {files}}',
                }, {
                  selectedFilesCount: selectedFiles.length,
                })}
              </Button>
            )}
            {!anyFilesFailed && submittedFiles.length > 0 && (
              <Button
                color="primary"
                disabled={incompletedFiles > 0 || saving}
                onClick={handleDone}
              >
                {finishing ? intl.formatMessage({ defaultMessage: 'Finishing...' }) :
                  intl.formatMessage({ defaultMessage: 'Done' })}
                <ProcessingProgress
                  show={saving && !finishing}
                  progress={{
                    total: submittedFiles.length,
                    done: submittedFiles.filter(f => f.uploadStatus === 'completed').length,
                  }}
                />
              </Button>
            )}
            {anyFilesFailed && (
              <Button
                color="primary"
                onClick={handleRetryAllFailed}
                className="uploaded-files-retry-failed"
              >
                {intl.formatMessage({ defaultMessage: 'Retry all failed files' })}
              </Button>
            )}
          </div>
        </Navbar>
      </Container>
    </div>
  );
};

UploadPageActionBar.propTypes = {
  submittedFiles: PropTypes.array.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  saving: PropTypes.bool.isRequired,
  finishing: PropTypes.bool.isRequired,
  incompletedFiles: PropTypes.number.isRequired,
  handleSelectAllFiles: PropTypes.func.isRequired,
  handleUnselectAllFiles: PropTypes.func.isRequired,
  handleRemoveSelectedFiles: PropTypes.func.isRequired,
  handleDone: PropTypes.func.isRequired,
  handleRetryAllFailed: PropTypes.func.isRequired,
  overallProgress: PropTypes.number.isRequired,
};

export default UploadPageActionBar;
